export default __webpack_public_path__ + "static/media/Kaisi-Paheli-Zindagani-Sunidhi-Chauhan.f91963fb.mp3";